import { FC } from 'react';

import SandComponentListing from 'components/main/SandComponent';

const SandComponent: FC = () => <SandComponentListing />;

export default SandComponent;
